export default __webpack_public_path__ + "static/media/EM0420.34I-22655_-16401_0.60e4487a.jpg";